var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Card, CardList, Spinner, useFlashContext, Button, } from "@lysaab/ui-2";
import { LysaCountry } from "@lysaab/shared";
import { NetsStatus, netsStatus } from "../../data/nets";
import { EIdProviderListItem } from "./EIdProviderListItem";
import { createJourney } from "./NetsJourney";
import { TrackerEvent } from "../../eventTracker/EventTracker";
import "./NetsSelect.scss";
import { keepPopupInFocus, openNetsPopup } from "./popup";
var eIdProviders = (_a = {},
    _a[LysaCountry.FINLAND] = ["fi_tupas", "fi_mobiilivarmenne"],
    _a[LysaCountry.DENMARK] = ["mitid"],
    _a[LysaCountry.SWEDEN] = [],
    _a[LysaCountry.GERMANY] = [],
    _a[LysaCountry.SPAIN] = [],
    _a);
export var NetsSelect = function (_a) {
    var _b;
    var initiate = _a.initiate, next = _a.next, netsDonePath = _a.netsDonePath, track = _a.track, country = _a.country, askForSsn = _a.askForSsn;
    var popup = useRef();
    var journey = useRef();
    var netsState = useRef("");
    var _c = useState(""), nonce = _c[0], setNonce = _c[1];
    var _d = useState(false), forceSsn = _d[0], setForceSsn = _d[1];
    var _e = useState(false), isWaiting = _e[0], setIsWaiting = _e[1];
    var _f = useState(false), showingSsnInfo = _f[0], setShowingSsnInfo = _f[1];
    var _g = useState(false), isNotACustomer = _g[0], setIsNotACustomer = _g[1];
    var _h = useFlashContext(), pushFlash = _h.pushFlash, dropFlash = _h.dropFlash;
    var intl = useIntl();
    var flashIds = useRef([]);
    var initiateNets = useRef();
    useEffect(function () {
        initiateNets.current = function () {
            return initiate().then(function (data) {
                track({
                    event: TrackerEvent.NETS_INIT,
                    message: {
                        state: data.state,
                        nonce: data.nonce,
                    },
                });
                netsState.current = data.state;
                setNonce(data.nonce);
            });
        };
    }, [initiate, track]);
    var confirmIdentification = useCallback(function () {
        var _a;
        function checkStatus(callCount, timeout) {
            var d = Date.now();
            var tId = setTimeout(function () {
                var _a;
                if (callCount >= 10) {
                    clearTimeout(tId);
                    (_a = journey.current) === null || _a === void 0 ? void 0 : _a.transition("CONFIRM_DONE", "restartJourney", {
                        reason: "confirmTimeout",
                    });
                }
                else {
                    netsStatus(netsState.current)
                        .then(function (status) {
                        var _a, _b;
                        if (status === NetsStatus.FAILED_INTERNAL ||
                            status === NetsStatus.TIMED_OUT) {
                            (_a = journey.current) === null || _a === void 0 ? void 0 : _a.transition("CONFIRM_DONE", "restartJourney", {
                                reason: status,
                            });
                        }
                        else if (status === NetsStatus.INITIATED) {
                            var deltaTime = Date.now() - d;
                            checkStatus(callCount + 1, Math.max(0, 300 - deltaTime));
                        }
                        else if (status === NetsStatus.SUCCESS) {
                            (_b = journey.current) === null || _b === void 0 ? void 0 : _b.transition("CONFIRM_DONE", "confirm");
                            next();
                        }
                    })
                        .catch(function (error) {
                        var _a;
                        (_a = journey.current) === null || _a === void 0 ? void 0 : _a.transition("CONFIRM_DONE", "restartJourney", {
                            reason: "catch",
                            error: error,
                        });
                    });
                }
            }, timeout);
        }
        (_a = journey.current) === null || _a === void 0 ? void 0 : _a.transition("DONE", "completed");
        checkStatus(0, 300);
    }, [next]);
    useEffect(function () {
        if (journey.current) {
            console.log("NetsJourney: Already created journey");
            return;
        }
        journey.current = createJourney(flashIds, pushFlash, dropFlash, intl, setIsWaiting, setShowingSsnInfo, setIsNotACustomer, confirmIdentification, track, initiateNets);
    }, [pushFlash, dropFlash, intl, confirmIdentification, track, initiateNets]);
    useEffect(function () {
        function onMessage(event) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
            if (event.data.status === "NETS_RETURNED") {
                if (((_a = journey.current) === null || _a === void 0 ? void 0 : _a.value) === "IDENTIFYING") {
                    (_b = journey.current) === null || _b === void 0 ? void 0 : _b.transition("IDENTIFYING", "completed", {
                        source: "message",
                    });
                }
                else if (((_c = journey.current) === null || _c === void 0 ? void 0 : _c.value) === "FINALIZING") {
                    (_d = journey.current) === null || _d === void 0 ? void 0 : _d.transition("FINALIZING", "confirm", {
                        source: "message",
                    });
                }
            }
            else if (event.data.status === "NETS_TIMED_OUT") {
                (_e = journey.current) === null || _e === void 0 ? void 0 : _e.transition((_f = journey.current) === null || _f === void 0 ? void 0 : _f.value, "netsTimedOut", event.data);
            }
            else if (event.data.status === "NETS_NEED_CPR") {
                (_g = journey.current) === null || _g === void 0 ? void 0 : _g.transition((_h = journey.current) === null || _h === void 0 ? void 0 : _h.value, "netsNeedCpr", event.data);
            }
            else if (event.data.status === "NETS_NOT_CUSTOMER") {
                (_j = journey.current) === null || _j === void 0 ? void 0 : _j.transition((_k = journey.current) === null || _k === void 0 ? void 0 : _k.value, "netsNotCustomer", event.data);
            }
            else if (event.data.status === "NETS_DONE") {
                if (((_l = journey.current) === null || _l === void 0 ? void 0 : _l.value) === "FINALIZING") {
                    (_m = journey.current) === null || _m === void 0 ? void 0 : _m.transition("FINALIZING", "completed", __assign(__assign({}, event.data), { source: "message" }));
                }
                else if (((_o = journey.current) === null || _o === void 0 ? void 0 : _o.value) === "DONE") {
                    (_p = journey.current) === null || _p === void 0 ? void 0 : _p.transition("DONE", "confirm", __assign(__assign({}, event.data), { source: "message" }));
                }
                else if (((_q = journey.current) === null || _q === void 0 ? void 0 : _q.value) === "CONFIRM_DONE") {
                    (_r = journey.current) === null || _r === void 0 ? void 0 : _r.transition("CONFIRM_DONE", "confirm", __assign(__assign({}, event.data), { source: "message" }));
                }
                else if (((_s = journey.current) === null || _s === void 0 ? void 0 : _s.value) === "PRE_SELECT") {
                }
            }
            else if (event.data.status === "NETS_ERROR") {
                if (((_t = journey.current) === null || _t === void 0 ? void 0 : _t.value) === "IDENTIFYING") {
                    (_u = journey.current) === null || _u === void 0 ? void 0 : _u.transition("IDENTIFYING", "netsError", __assign({}, event.data));
                }
                else if (((_v = journey.current) === null || _v === void 0 ? void 0 : _v.value) === "FINALIZING") {
                    (_w = journey.current) === null || _w === void 0 ? void 0 : _w.transition("FINALIZING", "netsError", __assign({}, event.data));
                }
                else if (((_x = journey.current) === null || _x === void 0 ? void 0 : _x.value) === "PRE_SELECT") {
                    (_y = journey.current) === null || _y === void 0 ? void 0 : _y.transition("PRE_SELECT", "netsError", __assign({}, event.data));
                }
            }
        }
        window.addEventListener("message", onMessage);
        return function () {
            window.removeEventListener("focus", keepPopupInFocus);
            window.removeEventListener("click", keepPopupInFocus);
            window.removeEventListener("message", onMessage);
        };
    }, []);
    useEffect(function () {
        var iId = setInterval(function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            try {
                if (!popup.current) {
                    return;
                }
                var href = popup.current.location.href;
                if (href === undefined) {
                    if (((_a = journey.current) === null || _a === void 0 ? void 0 : _a.value) === "POPUP_OPENED") {
                        (_b = journey.current) === null || _b === void 0 ? void 0 : _b.transition("POPUP_OPENED", "abort");
                    }
                    else if (((_c = journey.current) === null || _c === void 0 ? void 0 : _c.value) === "IDENTIFYING") {
                        (_d = journey.current) === null || _d === void 0 ? void 0 : _d.transition("IDENTIFYING", "abort");
                    }
                    else if (((_e = journey.current) === null || _e === void 0 ? void 0 : _e.value) === "FINALIZING") {
                        (_f = journey.current) === null || _f === void 0 ? void 0 : _f.transition("FINALIZING", "completed", {
                            source: "polling",
                        });
                    }
                }
                else {
                    if (((_g = journey.current) === null || _g === void 0 ? void 0 : _g.value) === "IDENTIFYING") {
                        (_h = journey.current) === null || _h === void 0 ? void 0 : _h.transition("IDENTIFYING", "completed", {
                            source: "polling",
                        });
                    }
                    else if (((_j = journey.current) === null || _j === void 0 ? void 0 : _j.value) === "FINALIZING") {
                        (_k = journey.current) === null || _k === void 0 ? void 0 : _k.transition("FINALIZING", "confirm", {
                            source: "polling",
                        });
                    }
                }
            }
            catch (e) {
                if (e instanceof DOMException && e.name === "SecurityError") {
                    if (((_l = journey.current) === null || _l === void 0 ? void 0 : _l.value) === "POPUP_OPENED") {
                        (_m = journey.current) === null || _m === void 0 ? void 0 : _m.transition("POPUP_OPENED", "sameOriginException");
                    }
                }
            }
        }, 1000);
        return function () {
            if (iId) {
                clearInterval(iId);
            }
        };
    }, [isWaiting, intl]);
    if (!netsState.current || !nonce || !country) {
        return _jsx(Spinner, {});
    }
    var signupUrl = (_b = process.env.REACT_APP_SIGNUP_URL) === null || _b === void 0 ? void 0 : _b.replace(":country", country.toLowerCase());
    return (_jsxs("div", __assign({ className: "nets-select" }, { children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "nets.header" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "nets.description" }) }), _jsxs("section", { children: [_jsxs(Card, __assign({ className: "overlay-card" + (isWaiting ? " ui-is-waiting-nets" : "") }, { children: [_jsx("div", __assign({ className: "spinner-wrapper" }, { children: isWaiting && _jsx(Spinner, {}) })), _jsx("p", { children: _jsx(FormattedMessage, { id: "nets.waiting" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "nets.find_click" }) })] })), _jsxs(Card, __assign({ className: "overlay-card" + (showingSsnInfo ? " ui-need-ssn" : "") }, { children: [_jsx("p", { children: _jsx(FormattedMessage, { id: "nets.need_ssn" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "nets.need_ssn_click" }) }), _jsx(Button, { block: true, onClick: function () {
                                    setForceSsn(true);
                                    setShowingSsnInfo(false);
                                }, label: _jsx(FormattedMessage, { id: "nets.need_ssn.button" }) })] })), _jsxs(Card, __assign({ className: "overlay-card" + (isNotACustomer ? " ui-is-not-a-customer" : "") }, { children: [_jsx("p", { children: _jsx(FormattedMessage, { id: "nets.go_to_signup" }) }), _jsx(Button, { block: true, component: "a", href: signupUrl, label: _jsx(FormattedMessage, { id: "nets.go_to_signup.button" }) })] })), _jsx(CardList, __assign({ className: "e-id-provider-card-list" + (isWaiting ? " ui-is-waiting-nets" : "") }, { children: eIdProviders[country].map(function (eIdProvider) { return (_jsx(EIdProviderListItem, { eIdProvider: eIdProvider, onClick: function (eIdProvider) {
                                var _a;
                                (_a = journey.current) === null || _a === void 0 ? void 0 : _a.transition("PRE_SELECT", "select", eIdProvider);
                                popup.current = openNetsPopup(eIdProvider, netsState.current, nonce, netsDonePath, askForSsn || forceSsn, journey.current);
                            } }, eIdProvider)); }) }))] })] })));
};
